module.exports = __webpack_public_path__ + "img/searching.04d065f5.png";